import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NAME_REDUCER } from './constants';
import actions from './actions';
import moment from 'moment';
import { CalendarAppointment, BlockHour } from 'types/models';

export interface ApptState {
  params: string;
  // initial value is a formatted string, but DatePicker onChange dispatches
  // a Moment object straight into setDate — both live here at runtime
  date: string | moment.Moment;
  appointments: CalendarAppointment[]; // mapped calendar appointments (mappingApt output)
  blockHours: BlockHour[]; // mapped block hours (mappingBlockHour output)
  loading: boolean;
  // range param of the last SUCCESSFUL fetch — lets views tell "no data for
  // this range yet" (blocking load) apart from "refreshing cached data"
  loadedParams: string;
}

const initialState: ApptState = {
  params: '',
  date: moment().format(),
  appointments: [],
  blockHours: [],
  loading: false,
  loadedParams: '',
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {
    setDate: (state, { payload }: PayloadAction<string | moment.Moment>) => {
      state.date = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(actions.getAptData.fetch, (state, { payload }) => {
        state.params = payload;
        state.loading = true;
      })
      .addCase(actions.getAptData.fail, (state) => {
        state.loading = false;
      })
      .addCase(actions.getAptData.success, (state, { payload }) => {
        state.appointments = payload;
        state.loading = false;
        state.loadedParams = state.params;
      })
      .addCase(actions.getBlockHourData.success, (state, { payload }) => {
        state.blockHours = payload;
      })
  },
});
export const aptUIActions = Slice.actions;
const aptServiceReducer = Slice.reducer;
export default aptServiceReducer;
